import React from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

// components
import { Rating } from "src/components/EventDetails/components";

//  utils
import { convertToSlug } from "src/utils/helpers";

// assets
import { LocationIcon, Calender } from "src/assets/icons";

import styles from "./EventItem.module.scss";
const cx = classNames.bind(styles);

const EventItem = ({ data }) => {
  const getUrl = () => {
    const slug = convertToSlug(data?.EventName);
    return `/${slug}/${data?.EventId}/${data?.TimeId}`;
  };

  return (
    <Link to={getUrl()}>
      <div className={cx("event-item-root")}>
        <div className={cx("img-wrapper")}>
          <img
            src={data.Image}
            alt={data.EventName}
            className={cx("main-image")}
          />
          <div className={cx("category")}>{data?.CategoryName}</div>
        </div>
        <div className={cx("content")}>
          <h4 className={cx("title")}>{data.EventName}</h4>
          <Rating size="xs" rate={0} />
          <p className={cx("location")}>
            <LocationIcon />
            <span>{data?.Location}</span>
          </p>
          <p className={cx("start-time")}>
            <Calender />
            <span>{data?.StartTime}</span>
          </p>
        </div>
      </div>
    </Link>
  );
};

export default EventItem;
